/**
 * @type {RequestInterceptor[]}
 */
const requestInterceptors = [];

/**
 * @type {ResponseInterceptor[]}
 */
const responseInterceptors = [];

/**
 * @param {RequestInterceptor} interceptor
 */
export const addRequestInterceptor = (interceptor) => {
    return requestInterceptors.push(interceptor);
};

/**
 * @param {ResponseInterceptor} interceptor
 */
export const addResponseInterceptor = (interceptor) => {
    return responseInterceptors.push(interceptor);
};

/**
 * @param {HttpRequestInfo} originalRequest
 * @returns {Promise<HttpRequestInfo>}
 */
export const applyRequestInterceptors = (originalRequest) => {
    return requestInterceptors.reduce((previous, interceptor) => {
        return previous.then(interceptor);
    }, Promise.resolve(originalRequest));
};

/**
 * @param {Promise<object>} originalResponse
 * @param {HttpRequestInfo} request
 * @returns {Promise<object>}
 */
export const applyResponseInterceptors = (originalResponse, request) => {
    return responseInterceptors.reduce((previous, interceptor) => {
        return previous.then((response) => {
            return interceptor(Promise.resolve(response), request);
        }, (error) => {
            return interceptor(Promise.reject(error), request);
        });
    }, originalResponse);
};

/**
 * @typedef {import('./interfaces').HttpRequestInfo} HttpRequestInfo
 * @typedef {import('./interfaces').RequestInterceptor} RequestInterceptor
 * @typedef {import('./interfaces').ResponseInterceptor} ResponseInterceptor
 */
